import { render, staticRenderFns } from "./CalibratorCase.vue?vue&type=template&id=820af928&scoped=true&lang=pug"
import script from "./CalibratorCase.vue?vue&type=script&lang=js"
export * from "./CalibratorCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820af928",
  null
  
)

export default component.exports